import { apiRequest } from '@/shared/api/client';

export async function logout(): Promise<void> {
  await apiRequest<void>('/v1/auth/logout', {
    method: 'POST',
    json: {},
  });
}
